var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useDesign from '../../../hooks/useDesign';
import { TranslatedText } from '../../atoms/TranslatedText/TranslatedText';
import { StyledPoweredBy } from './styled';
export var PoweredBy = function (_a) {
    var design = _a.design;
    var _b = useDesign(design), components = _b.components, schema = _b.schema;
    var logo = useDesign(components.icon);
    return (_jsxs(StyledPoweredBy, __assign({ schema: schema }, { children: [_jsx(TranslatedText, { design: components.translatedText }), _jsx("img", __assign({}, logo.config, { alt: "logo" }))] })));
};
PoweredBy.displayName = 'PoweredBy';
export * from './PoweredBy.types';
